import React, { useEffect } from 'react';
import styles from '../capitalExpenditure.module.scss';
import FirstQuarter from '../quarters/FirstQuarter';
import SecondQuarter from '../quarters/SecondQuarter';
import ThirdQuarter from '../quarters/ThirdQuarter';
import FourthQuarter from '../quarters/FourthQuarter';
import BasicInfoRow from './BasicInfoRow';
import SummaryRow from './SummaryRow';
import IncomeTotalRow from './IncomeTotalRow';
import { parseNumericValue, calculateTotalWithFormatDetection, calculateComplexTotalWithFormatDetection, calculateCombinedTotalWithFormatDetection } from '../utils/numberUtils';
import InputField from './InputField';

const CapitalExpenditureForm = ({
  rows,
  operationalRows,
  viewMode,
  handleInputChange,
  handleOperationalRowChange,
  addRow,
  addOperationalRow,
  removeRow,
  handleSubmit,
  handleReset,
  handleClearForNewData,
  handleDownloadFormData,
  selectedFiscalYear,
  setSelectedFiscalYear,
  fiscalYears,
  loading,
  onItemUpdate,
  onItemDelete,
  onLoadExistingData,
  selectedOffice,
  isAuthenticated = false,
  onToggleViewMode,
  incomeTotals,
  onIncomeChange
}) => {

  console.log('CapitalExpenditureForm - selectedFiscalYear:', selectedFiscalYear);
  console.log('CapitalExpenditureForm - fiscalYears:', fiscalYears);
  console.log('CapitalExpenditureForm - rows:', rows);
  console.log('CapitalExpenditureForm - operationalRows:', operationalRows);
  console.log('CapitalExpenditureForm - viewMode:', viewMode);
  console.log('CapitalExpenditureForm - isAuthenticated:', isAuthenticated);
  
  // Monitor changes in rows and operationalRows
  useEffect(() => {
    console.log('Rows changed:', rows);
  }, [rows]);
  
  useEffect(() => {
    console.log('Operational rows changed:', operationalRows);
  }, [operationalRows]);
  
  return (
    <div className={styles.formContainer}>

      <form onSubmit={handleSubmit}>
        <div className={styles.tableContainer}>
          <table className={styles.expenditureTable}>
                         <thead>
               <tr className={styles.mainHeader}>
                 <th rowSpan="2" className={styles.codeHeader}>कोड नं.</th>
                 <th rowSpan="2" className={styles.titleHeader}>खर्च शिर्षक</th>
                 <th rowSpan="2" className={`${styles.budgetHeader} ${styles.budgetHeaderSticky3}`}>बिनियोजित बजेट</th>
                 <th rowSpan="2" className={`${styles.budgetHeader} ${styles.budgetHeaderSticky4}`}>परिमार्जीत बजेट</th>
                 <th colSpan="5" className={styles.quarterHeader}>प्रथम त्रैमासिक</th>
                 <th colSpan="5" className={styles.quarterHeader}>दोस्रो त्रैमासिक</th>
                 <th colSpan="5" className={styles.quarterHeader}>तेस्रो त्रैमासिक</th>
                 <th colSpan="5" className={styles.quarterHeader}>चौथो त्रैमासिक</th>
                 <th colSpan="5" className={styles.summaryHeader}>यस आ.व.को कुल बजेट विवरण</th>
                 <th colSpan="1" className={styles.differenceHeader}>विनियोजित बजेट र अर्च विचको भिन्नता</th>
               </tr>
               <tr className={styles.subHeader}>
                 <th className={styles.subHeaderCell}>बजेट माग</th>
                 <th className={styles.subHeaderCell}>बजेट निकासा</th>
                 <th className={styles.subHeaderCell}>अख्तियारी प्राप्त</th>
                 <th className={styles.subHeaderCell}>खर्च</th>
                 <th className={styles.subHeaderCell}>बाँकि मौज्दात</th>
                 <th className={styles.subHeaderCell}>बजेट माग</th>
                 <th className={styles.subHeaderCell}>बजेट निकासा</th>
                 <th className={styles.subHeaderCell}>अख्तियारी प्राप्त</th>
                 <th className={styles.subHeaderCell}>खर्च</th>
                 <th className={styles.subHeaderCell}>बाँकि मौज्दात</th>
                 <th className={styles.subHeaderCell}>बजेट माग</th>
                 <th className={styles.subHeaderCell}>बजेट निकासा</th>
                 <th className={styles.subHeaderCell}>अख्तियारी प्राप्त</th>
                 <th className={styles.subHeaderCell}>खर्च</th>
                 <th className={styles.subHeaderCell}>बाँकि मौज्दात</th>
                 <th className={styles.subHeaderCell}>बजेट माग</th>
                 <th className={styles.subHeaderCell}>बजेट निकासा</th>
                 <th className={styles.subHeaderCell}>अख्तियारी प्राप्त</th>
                 <th className={styles.subHeaderCell}>खर्च</th>
                 <th className={styles.subHeaderCell}>बाँकि मौज्दात</th>
                 <th className={styles.subHeaderCell}>कुल बजेट माग</th>
                 <th className={styles.subHeaderCell}>कुल बजेट निकासा</th>
                 <th className={styles.subHeaderCell}>कुल अख्तियारी प्राप्त</th>
                 <th className={styles.subHeaderCell}>कुल खर्च</th>
                 <th className={styles.subHeaderCell}>जम्मा मौज्दात</th>
                 <th className={styles.subHeaderCell}>भिन्नता</th>
               </tr>
             </thead>
            <tbody>
                             {/* Capital Expenditure Section */}
               <tr className={styles.categoryRow}>
                 <td colSpan="4" className={`${styles.categoryCell} ${styles.stickyColGroup4}`}>पुँजीगत खर्च</td>
                 <td colSpan="26" className={styles.categoryCell}></td>
               </tr>
              
                                                           {rows.filter(row => (row.codeNumber && row.expenseTitle) || row.isNewlyAdded).map((row) => {
                 return (
                   <tr key={row.id} className={styles.dataRow}>
                     {/* Basic Info */}
                     <BasicInfoRow
                       row={row}
                       viewMode={viewMode}
                       handleInputChange={handleInputChange}
                     />
                     
                     {/* Quarter 1 */}
                     <FirstQuarter 
                       row={row}
                       viewMode={viewMode}
                       handleInputChange={handleInputChange}
                     />
                     
                     {/* Quarter 2 */}
                     <SecondQuarter 
                       row={row}
                       viewMode={viewMode}
                       handleInputChange={handleInputChange}
                     />
                     
                     {/* Quarter 3 */}
                     <ThirdQuarter 
                       row={row}
                       viewMode={viewMode}
                       handleInputChange={handleInputChange}
                     />
                     
                     {/* Quarter 4 */}
                     <FourthQuarter 
                       row={row}
                       viewMode={viewMode}
                       handleInputChange={handleInputChange}
                     />
                     
                     {/* Summary Columns */}
                     <SummaryRow
                       row={row}
                       viewMode={viewMode}
                       handleInputChange={handleInputChange}
                       budgetAllocationDifference={parseNumericValue(row.revisedBudget) - parseNumericValue(row.totalBudgetDemand)}
                     />
                     
                     {/* Action Buttons */}
                     <td className={styles.actionCell}>
                       {!viewMode && isAuthenticated && (
                         <button
                           type="button"
                           onClick={() => {
                             // If row has a numeric ID from backend, use delete function
                             if (typeof row.id === 'number' && row.id > 0) {
                               onItemDelete(row.id);
                             } else {
                               // If it's a local row, use remove function
                               removeRow(row.id);
                             }
                           }}
                           className={styles.removeButton}
                         >
                           हटाउनुहोस्
                         </button>
                       )}
                     </td>
                   </tr>
                 );
               })}
              
               {/* Capital Expenditure Total Row */}
               <tr className={styles.totalRow}>
                 <td colSpan="2" className={`${styles.totalLabel} ${styles.stickyColGroup2}`}>जम्मा पुँजीगत</td>
                 <td className={`${styles.budgetCell} ${styles.stickyCol3}`}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'unallocatedBudget')}
                     onChange={(value) => handleInputChange(null, 'unallocatedBudget', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={`${styles.budgetCell} ${styles.stickyCol4}`}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'revisedBudget')}
                     onChange={(value) => handleInputChange(null, 'revisedBudget', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q1BudgetDemand')}
                     onChange={(value) => handleInputChange(null, 'q1BudgetDemand', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q1BudgetExpenditure')}
                     onChange={(value) => handleInputChange(null, 'q1BudgetExpenditure', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q1AuthorityReceived')}
                     onChange={(value) => handleInputChange(null, 'q1AuthorityReceived', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q1Expense')}
                     onChange={(value) => handleInputChange(null, 'q1Expense', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q1RemainingBalance')}
                     onChange={(value) => handleInputChange(null, 'q1RemainingBalance', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q2BudgetDemand')}
                     onChange={(value) => handleInputChange(null, 'q2BudgetDemand', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q2BudgetExpenditure')}
                     onChange={(value) => handleInputChange(null, 'q2BudgetExpenditure', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q2AuthorityReceived')}
                     onChange={(value) => handleInputChange(null, 'q2AuthorityReceived', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q2Expense')}
                     onChange={(value) => handleInputChange(null, 'q2Expense', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q2RemainingBalance')}
                     onChange={(value) => handleInputChange(null, 'q2RemainingBalance', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q3BudgetDemand')}
                     onChange={(value) => handleInputChange(null, 'q3BudgetDemand', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q3BudgetExpenditure')}
                     onChange={(value) => handleInputChange(null, 'q3BudgetExpenditure', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q3AuthorityReceived')}
                     onChange={(value) => handleInputChange(null, 'q3AuthorityReceived', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q3Expense')}
                     onChange={(value) => handleInputChange(null, 'q3Expense', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q3RemainingBalance')}
                     onChange={(value) => handleInputChange(null, 'q3RemainingBalance', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q4BudgetDemand')}
                     onChange={(value) => handleInputChange(null, 'q4BudgetDemand', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q4BudgetExpenditure')}
                     onChange={(value) => handleInputChange(null, 'q4BudgetExpenditure', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q4AuthorityReceived')}
                     onChange={(value) => handleInputChange(null, 'q4AuthorityReceived', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q4Expense')}
                     onChange={(value) => handleInputChange(null, 'q4Expense', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'q4RemainingBalance')}
                     onChange={(value) => handleInputChange(null, 'q4RemainingBalance', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'totalBudgetDemand')}
                     onChange={(value) => handleInputChange(null, 'totalBudgetDemand', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'totalBudgetExpenditure')}
                     onChange={(value) => handleInputChange(null, 'totalBudgetExpenditure', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'totalAuthorityReceived')}
                     onChange={(value) => handleInputChange(null, 'totalAuthorityReceived', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'totalExpense')}
                     onChange={(value) => handleInputChange(null, 'totalExpense', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateTotalWithFormatDetection(rows, 'totalRemainingBalance')}
                     onChange={(value) => handleInputChange(null, 'totalRemainingBalance', value)}
                     disabled={viewMode}
                   />
                 </td>
                 <td className={styles.budgetCell}>
                   <InputField
                     value={calculateComplexTotalWithFormatDetection(rows, (row) => 
                       parseNumericValue(row.revisedBudget) - parseNumericValue(row.totalBudgetDemand)
                     )}
                     onChange={(value) => handleInputChange(null, 'budgetAllocationDifference', value)}
                     disabled={viewMode}
                   />
                 </td>
               </tr>
               
               {/* Add Capital Row Button */}
               {isAuthenticated && (
                 <tr>
                   <td colSpan="30" className={styles.addRowCell}>
                     <button
                       type="button"
                       onClick={addRow}
                       className={styles.addRowButton}
                     >
                       पुँजीगत खर्च (+ पंक्ति थप्नुहोस्)
                     </button>
                   </td>
                 </tr>
               )}
               
               {/* Operational Expenditure Section */}
               <tr className={styles.categoryRow}>
                 <td colSpan="4" className={`${styles.categoryCell} ${styles.stickyColGroup4}`}>संचालन खर्च</td>
                 <td colSpan="26" className={styles.categoryCell}></td>
               </tr>
               
                                                                   {operationalRows.filter(row => (row.codeNumber && row.expenseTitle) || row.isNewlyAdded).map((row, index) => {
                   return (
                     <tr key={row.id} className={styles.dataRow}>
                       {/* Basic Info */}
                       <BasicInfoRow
                         row={row}
                         viewMode={viewMode}
                         handleInputChange={handleInputChange}
                         handleOperationalRowChange={handleOperationalRowChange}
                         isOperational={true}
                       />
                       
                       {/* Quarter 1 */}
                       <FirstQuarter 
                         row={row}
                         viewMode={viewMode}
                         handleInputChange={handleInputChange}
                         handleOperationalRowChange={handleOperationalRowChange}
                         isOperational={true}
                       />
                       
                       {/* Quarter 2 */}
                       <SecondQuarter 
                         row={row}
                         viewMode={viewMode}
                         handleInputChange={handleInputChange}
                         handleOperationalRowChange={handleOperationalRowChange}
                         isOperational={true}
                       />
                       
                       {/* Quarter 3 */}
                       <ThirdQuarter 
                         row={row}
                         viewMode={viewMode}
                         handleInputChange={handleInputChange}
                         handleOperationalRowChange={handleOperationalRowChange}
                         isOperational={true}
                       />
                       
                       {/* Quarter 4 */}
                       <FourthQuarter 
                         row={row}
                         viewMode={viewMode}
                         handleInputChange={handleInputChange}
                         handleOperationalRowChange={handleOperationalRowChange}
                         isOperational={true}
                       />
                       
                       {/* Summary Columns */}
                       <SummaryRow
                         row={row}
                         viewMode={viewMode}
                         handleInputChange={handleInputChange}
                         handleOperationalRowChange={handleOperationalRowChange}
                         isOperational={true}
                         budgetAllocationDifference={parseNumericValue(row.revisedBudget) - parseNumericValue(row.totalBudgetDemand)}
                       />
                       
                       {/* Action Buttons */}
                       <td className={styles.actionCell}>
                         {!viewMode && isAuthenticated && (
                           <button
                             type="button"
                             onClick={() => {
                               // If row has a numeric ID from backend, use delete function
                               if (typeof row.id === 'number' && row.id > 0) {
                                 onItemDelete(row.id);
                               } else {
                                 // If it's a local row, use remove function
                                 removeRow(row.id);
                               }
                             }}
                             className={styles.removeButton}
                           >
                             हटाउनुहोस्
                           </button>
                         )}
                       </td>
                     </tr>
                   );
                 })}
                
                {/* Operational Expenditure Total Row */}
                <tr className={styles.totalRow}>
                  <td colSpan="2" className={`${styles.totalLabel} ${styles.stickyColGroup2}`}>जम्मा संचालन</td>
                                     <td className={`${styles.budgetCell} ${styles.stickyCol3}`}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'unallocatedBudget')}
                       onChange={(value) => handleInputChange(null, 'unallocatedBudget', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={`${styles.budgetCell} ${styles.stickyCol4}`}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'revisedBudget')}
                       onChange={(value) => handleInputChange(null, 'revisedBudget', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q1BudgetDemand')}
                       onChange={(value) => handleInputChange(null, 'q1BudgetDemand', value)}
                       disabled={viewMode}
                     />
                   </td>
                                     <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q1BudgetExpenditure')}
                       onChange={(value) => handleInputChange(null, 'q1BudgetExpenditure', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q1AuthorityReceived')}
                       onChange={(value) => handleInputChange(null, 'q1AuthorityReceived', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q1Expense')}
                       onChange={(value) => handleInputChange(null, 'q1Expense', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q1RemainingBalance')}
                       onChange={(value) => handleInputChange(null, 'q1RemainingBalance', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q2BudgetDemand')}
                       onChange={(value) => handleInputChange(null, 'q2BudgetDemand', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q2BudgetExpenditure')}
                       onChange={(value) => handleInputChange(null, 'q2BudgetExpenditure', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q2AuthorityReceived')}
                       onChange={(value) => handleInputChange(null, 'q2AuthorityReceived', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q2Expense')}
                       onChange={(value) => handleInputChange(null, 'q2Expense', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q2RemainingBalance')}
                       onChange={(value) => handleInputChange(null, 'q2RemainingBalance', value)}
                       disabled={viewMode}
                     />
                   </td>
                                     <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q3BudgetDemand')}
                       onChange={(value) => handleInputChange(null, 'q3BudgetDemand', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q3BudgetExpenditure')}
                       onChange={(value) => handleInputChange(null, 'q3BudgetExpenditure', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q3AuthorityReceived')}
                       onChange={(value) => handleInputChange(null, 'q3AuthorityReceived', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q3Expense')}
                       onChange={(value) => handleInputChange(null, 'q3Expense', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q3RemainingBalance')}
                       onChange={(value) => handleInputChange(null, 'q3RemainingBalance', value)}
                       disabled={viewMode}
                     />
                   </td>
                                     <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q4BudgetDemand')}
                       onChange={(value) => handleInputChange(null, 'q4BudgetDemand', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q4BudgetExpenditure')}
                       onChange={(value) => handleInputChange(null, 'q4BudgetExpenditure', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q4AuthorityReceived')}
                       onChange={(value) => handleInputChange(null, 'q4AuthorityReceived', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q4Expense')}
                       onChange={(value) => handleInputChange(null, 'q4Expense', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'q4RemainingBalance')}
                       onChange={(value) => handleInputChange(null, 'q4RemainingBalance', value)}
                       disabled={viewMode}
                     />
                   </td>
                                     <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'totalBudgetDemand')}
                       onChange={(value) => handleInputChange(null, 'totalBudgetDemand', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'totalBudgetExpenditure')}
                       onChange={(value) => handleInputChange(null, 'totalBudgetExpenditure', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'totalAuthorityReceived')}
                       onChange={(value) => handleInputChange(null, 'totalAuthorityReceived', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'totalExpense')}
                       onChange={(value) => handleInputChange(null, 'totalExpense', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateTotalWithFormatDetection(operationalRows, 'totalRemainingBalance')}
                       onChange={(value) => handleInputChange(null, 'totalRemainingBalance', value)}
                       disabled={viewMode}
                     />
                   </td>
                   <td className={styles.budgetCell}>
                     <InputField
                       type="text"
                       value={calculateComplexTotalWithFormatDetection(operationalRows, (row) => 
                         parseNumericValue(row.revisedBudget) - parseNumericValue(row.totalBudgetDemand)
                       )}
                       onChange={(value) => handleInputChange(null, 'budgetAllocationDifference', value)}
                       disabled={viewMode}
                     />
                   </td>
                </tr>
                
                {/* Combined Total Row - Operational + Capital */}
                <tr className={styles.totalRow}>
                  <td colSpan="2" className={`${styles.totalLabel} ${styles.stickyColGroup2}`}>जम्मा संचालन र पुँजीगत खर्च</td>
                  <td className={`${styles.budgetCell} ${styles.stickyCol3}`}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'unallocatedBudget')}
                      onChange={(value) => handleInputChange(null, 'unallocatedBudget', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={`${styles.budgetCell} ${styles.stickyCol4}`}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'revisedBudget')}
                      onChange={(value) => handleInputChange(null, 'revisedBudget', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q1BudgetDemand')}
                      onChange={(value) => handleInputChange(null, 'q1BudgetDemand', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q1BudgetExpenditure')}
                      onChange={(value) => handleInputChange(null, 'q1BudgetExpenditure', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q1AuthorityReceived')}
                      onChange={(value) => handleInputChange(null, 'q1AuthorityReceived', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q1Expense')}
                      onChange={(value) => handleInputChange(null, 'q1Expense', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q1RemainingBalance')}
                      onChange={(value) => handleInputChange(null, 'q1RemainingBalance', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q2BudgetDemand')}
                      onChange={(value) => handleInputChange(null, 'q2BudgetDemand', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q2BudgetExpenditure')}
                      onChange={(value) => handleInputChange(null, 'q2BudgetExpenditure', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q2AuthorityReceived')}
                      onChange={(value) => handleInputChange(null, 'q2AuthorityReceived', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q2Expense')}
                      onChange={(value) => handleInputChange(null, 'q2Expense', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q2RemainingBalance')}
                      onChange={(value) => handleInputChange(null, 'q2RemainingBalance', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q3BudgetDemand')}
                      onChange={(value) => handleInputChange(null, 'q3BudgetDemand', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q3BudgetExpenditure')}
                      onChange={(value) => handleInputChange(null, 'q3BudgetExpenditure', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q3AuthorityReceived')}
                      onChange={(value) => handleInputChange(null, 'q3AuthorityReceived', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q3Expense')}
                      onChange={(value) => handleInputChange(null, 'q3Expense', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q3RemainingBalance')}
                      onChange={(value) => handleInputChange(null, 'q3RemainingBalance', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q4BudgetDemand')}
                      onChange={(value) => handleInputChange(null, 'q4BudgetDemand', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q4BudgetExpenditure')}
                      onChange={(value) => handleInputChange(null, 'q4BudgetExpenditure', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q4AuthorityReceived')}
                      onChange={(value) => handleInputChange(null, 'q4AuthorityReceived', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q4Expense')}
                      onChange={(value) => handleInputChange(null, 'q4Expense', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'q4RemainingBalance')}
                      onChange={(value) => handleInputChange(null, 'q4RemainingBalance', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'totalBudgetDemand')}
                      onChange={(value) => handleInputChange(null, 'totalBudgetDemand', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'totalBudgetExpenditure')}
                      onChange={(value) => handleInputChange(null, 'totalBudgetExpenditure', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'totalAuthorityReceived')}
                      onChange={(value) => handleInputChange(null, 'totalAuthorityReceived', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'totalExpense')}
                      onChange={(value) => handleInputChange(null, 'totalExpense', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateCombinedTotalWithFormatDetection(operationalRows, rows, 'totalRemainingBalance')}
                      onChange={(value) => handleInputChange(null, 'totalRemainingBalance', value)}
                      disabled={viewMode}
                    />
                  </td>
                  <td className={styles.budgetCell}>
                    <InputField
                      type="text"
                      value={calculateComplexTotalWithFormatDetection([...operationalRows, ...rows], (row) => 
                        parseNumericValue(row.revisedBudget) - parseNumericValue(row.totalBudgetDemand)
                      )}
                      onChange={(value) => handleInputChange(null, 'budgetAllocationDifference', value)}
                      disabled={viewMode}
                    />
                  </td>
                </tr>

                <IncomeTotalRow
                  incomeTotals={incomeTotals}
                  onIncomeChange={onIncomeChange}
                  viewMode={viewMode}
                />
               
               {/* Add Operational Row Button */}
               {isAuthenticated && (
                 <tr>
                   <td colSpan="30" className={styles.addRowCell}>
                     <button
                       type="button"
                       onClick={addOperationalRow}
                       className={styles.addRowButton}
                     >
                       संचालन खर्च (+ पंक्ति थप्नुहोस्)
                     </button>
                   </td>
                 </tr>
               )}
               

               

            </tbody>
          </table>
        </div>
        
        {/* Form Actions */}
        <div className={styles.buttonContainer}>
          {viewMode && (
            <div className={styles.viewModeInfo}>
              <span className={styles.viewModeText}>📖 हालको मोड: डाटा हेर्नुहोस्</span>
              <button
                type="button"
                onClick={onToggleViewMode}
                className={styles.toggleViewButton}
              >
                सम्पादन गर्नुहोस्
              </button>
            </div>
          )}
          
          <button
            type="submit"
            disabled={loading || viewMode}
            className={styles.submitButton}
          >
            {loading ? 'सेभ गर्दै...' : 'सेभ गर्नुहोस्'}
          </button>
          
          <button 
            type="button" 
            className={styles.loadDataButton}
            onClick={onLoadExistingData}
            disabled={loading || !selectedFiscalYear || !selectedOffice?.id}
          >
            मौजदा डाटा लोड गर्नुहोस्
          </button>
          
          <button 
            type="button" 
            className={styles.newDataButton}
            onClick={handleClearForNewData}
            disabled={loading}
          >
            नयाँ डाटा थप्नुहोस्
          </button>
          
          {isAuthenticated && (
            <button 
              type="button" 
              className={styles.resetButton}
              onClick={handleReset}
              disabled={loading}
            >
              रिसेट गर्नुहोस्
            </button>
          )}
          
          <button 
            type="button" 
            className={styles.excelButton}
            onClick={handleDownloadFormData}
            disabled={loading || !selectedFiscalYear || !selectedOffice?.id}
            title="डाटा Excel मा डाउनलोड गर्नुहोस्"
          >
            📊 डाटा हेर्नुहोस्
          </button>
        </div>
      </form>
    </div>
  );
};

export default CapitalExpenditureForm;
